"use client";

import { MapProvider } from "@/providers/map";
import { Filters } from "@/types/filters";
import { ReactNode } from "react";
// import { SearchPageProvider } from "../../providers/search";
import { UrlFiltersProvider } from "@/hooks/use-url-filters";
import { SearchPageProvider } from "@/providers/search";
import { Pagination } from "@/providers/search/stores/list-store";
import { Bounds } from "@/providers/search/stores/map-store";
import type { ListItem, MapItem, MapItemSUP, MapItemWithCoodId } from "@/types/search";

interface SearchWithMapProps {
	children: ReactNode;
	slug?: string; // URL slug for SSR-friendly filter initialization
	initialPropertyFilters?: Partial<Filters>;
	initialListData?: ListItem[];
	initialPagination?: Pagination;
	initialMapData?: MapItem[] | MapItemWithCoodId[];
	initialBounds?: Bounds | null;
	initialMapCenter?: { lat: number; lng: number };
	initialMapZoom?: number | null;
	mapId?: string;
	initialFavorites?: MapItemSUP[]; // Replace 'string' with your actual favorite item type if needed
	header: ReactNode;
	initialTotalCount?: number | null;
}

export function SearchWithMap({
	children,
	slug,
	initialPropertyFilters,
	initialListData,
	initialPagination,
	initialMapData,
	initialBounds,
	initialMapCenter,
	initialMapZoom,
	mapId,
	initialFavorites,
	header,
	initialTotalCount,
}: SearchWithMapProps) {
	// Extract locations from initialPropertyFilters to pass to SearchPageProvider
	const initialLocations = initialPropertyFilters?.locations || [];

	return (
		<MapProvider>
			<SearchPageProvider
				slug={slug}
				initialListData={initialListData}
				initialPagination={initialPagination}
				initialMapData={initialMapData}
				initialBounds={initialBounds}
				initialMapCenter={initialMapCenter}
				initialMapZoom={initialMapZoom}
				mapId={mapId}
				initialFavorites={initialFavorites}
				initialLocations={initialLocations}
				initialTotalCount={initialTotalCount}
			>
				<UrlFiltersProvider initialFilters={initialPropertyFilters}>
					{header}
					{children}
				</UrlFiltersProvider>
			</SearchPageProvider>
		</MapProvider>
	);
}
